/**
 * ── Cutting the mystery build-up short — GDD §13 ──
 *
 * A press ENDS the build-up on the frame it arrives and the doors open next.
 * Not faster, not shorter — over. The player who taps has said they do not want
 * to watch the wait, and any version that still makes them watch something is
 * the same complaint in a smaller size.
 *
 * ── Why cutting mid-clip is safe here, when it usually is not ──
 *
 * Two earlier attempts were worse, and both for the same reason: they left a
 * performance running.
 *
 *   timeScale     played the SAME two passes quickly. `anticipation_strong` is
 *                 one 2.0s clip authored as its own 1.0s cycle twice, so
 *                 speeding it showed the repeat rather than removing it.
 *   animationEnd  truncated it to one pass — better, but a press at t=0.05
 *                 still bought a full second of waiting.
 *
 * The cut is invisible because of what the doors actually do. Across the whole
 * build-up they jitter by at most 12px left and 20px right; the `reveal` that
 * follows swings them 95px and 115px. So the discontinuity is smaller than the
 * first frame of the motion that covers it.
 *
 * And it never even paints: the phase after this one is queued in the SAME task
 * the skip resolves in — `_injectGolden` and the reveal's own setup are both
 * synchronous — so the track is replaced before the renderer runs. The
 * interrupted pose is a value in memory, not a frame anyone sees.
 *
 * ── One group ──
 *
 * Every covered cell plays this clip at the same moment and they open together,
 * so one press takes all of them. Cutting them one at a time — the way the
 * coins cascade is cut — would leave half the board tense and half revealing.
 * See spinSkipRegistry's group support.
 *
 * ── What is NOT skippable ──
 *
 * Only the build-up. The doors, the lid and the settle are the reveal itself —
 * they are what the player pressed FOR, and cutting them would answer the
 * request by deleting the thing it was asking to reach.
 *
 * Both tiers are registered, short and long alike. The short clip is only 0.5s
 * and hardly needs it, but a press that lands during it and does nothing reads
 * as the game ignoring you, which is the fault being fixed.
 */
export const MYSTERY_SKIP_GROUP = "mystery_anticipation";
